//EXAMPLE - inherited basics + override behavior
import { Placement } from "./Placement";
import { THEME_TILES_MAP } from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";

export class WallPlacement extends Placement {
  isSolid() {
    return true;
  }

  renderComponent() {
    const wallTileCoord = THEME_TILES_MAP[this.level.theme].WALL;
    return <Sprite frameCoord={wallTileCoord} />;
  }
}
